import React, { Component } from 'react';
import { ContentDiv, BodyHeaderDiv, BodyHeaderText } from '../../theme/MorsTheme';
import { Pagination, Row, Col, Form, Container } from 'react-bootstrap';
import '../TaxReports/css/TaxReports.css'
import { enableCwtReprint, getTaxReportRequestLogs } from '../../Utilities/WSUtil';
// import Table from 'react-bootstrap/Table';
import { paginate, pager } from '../../Utilities/PaginateUtil';

const DataHelper = {

    filterByMid: (data, mid) => {

        if (!mid) {
            return data;
        }
        return data.filter(item => item.mid.includes(mid))
        // return data.filter(item => item.mid == mid)
    }
}

const TaxReportHelper = {
    addLastPrintedStatus: (data) => {
        var result = data;

        if (data) {
            // result = data.reverse();
            result.forEach(item => { item.isLast = true; item.selected = false; });
            // how to check if last updated
            // initialy false, reverse
            if (result.length > 1) {
                for (var i = 1; i < result.length; i++) {
                    result.selected = false;
                    if (result[i - 1].cwt == result[i].cwt) {
                        result[i - 1].isLast = false;
                    }
               }
            }

            return result;

        }
        return data;
    }
}
class TaxReprintList extends Component {
    searchResults = [];
    forPrint = [];
    constructor(props) {
        super(props);
        this.onSearch = this.onSearch.bind(this);
        this.goBack = this.goBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);

        this.state = {
            currentPage: 1,
            totalPages: 0,
            itemsPerPage: 20,
            pager: {},
            pageOfItems: [],
            inputValue: '',
            valid: false,
            items: [],
            filteredItems: []
        }
        this.searchResults = this.props.items;
    }

    onSearch(event) {

        this.setState({ inputValue: event.target.value })

        const filter = this.state.items.filter(i => i.mid.includes(event.target.value));
        const res = pager(filter, 1, this.state.itemsPerPage);
        this.setState({
            pageOfItems: res.items,
            totalPages: res.totalPages,
            currentPage: 1,
            filteredItems: filter
        });
    }

    first() {
        // if (this.state.pageOfItems.length > 0) {
        //     const res = pager(this.state.items, 1, this.state.itemsPerPage);
        //     this.setState({ currentPage: 1, pageOfItems: res.items, totalPages: res.totalPages })
        // }
        const res = pager(this.state.filteredItems, 1, this.state.itemsPerPage);
        this.setState({ currentPage: 1, pageOfItems: res.items, totalPages: res.totalPages })
    }

    previous() {
        const page = this.state.currentPage;
        const prevPage = page - 1;
        if (prevPage > 0) {

            const res = pager(this.state.filteredItems, prevPage, this.state.itemsPerPage);
            this.setState({ currentPage: prevPage, pageOfItems: res.items, totalPages: res.totalPages })
        }
    }

    next() {

        const page = this.state.currentPage;
        const nextPage = page + 1;

        if (nextPage <= this.state.totalPages) {
            const res = pager(this.state.filteredItems, nextPage, this.state.itemsPerPage);
            this.setState({ currentPage: nextPage, pageOfItems: res.items, totalPages: res.totalPages })
        }
    }

    last() {
        const items = this.state.items;
        if (items && items.length > 0) {
            const res = pager(this.state.filteredItems, this.state.totalPages, this.state.itemsPerPage);
            this.setState({ currentPage: res.totalPages, pageOfItems: res.items, totalPages: res.totalPages })
        }
    }

    pager(data, page, filter) {

        if (data && data.length > 0) {

            var items = data;

            if (this.state.inputValue) {
                items = data.filter(i => i.mid.includes(filter));
            }

            var pageSize = this.state.itemsPerPage;
            var totalPages = Math.ceil(items.length / pageSize);

            if (page >= 1 || page <= totalPages) {
                var startIndex = (page - 1) * pageSize;
                var endIndex = Math.min(startIndex + pageSize - 1, data.length - 1);
                var currentPageItems = items.slice(startIndex, endIndex + 1);
                return currentPageItems;
            }
        }
        return [];
    }

    loadData() {

        var val = pager(this.props.items, 1, this.state.itemsPerPage);
        var totalPages = Math.ceil(this.props.items.length / this.state.itemsPerPage);
        this.setState({ currentPage: 1, totalPages: totalPages, items: this.props.items, filteredItems: this.props.items, pageOfItems: val.items, valid: false });
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.items !== prevProps.items) {
            // this.setPage(this.props.initialPage);
            this.loadData();
        }
        // if (this.state.items != prevProps.items) {
        //     this.currentPage = 1;
        // }
    }

    filterItems(items, search) {
        const newArray = DataHelper.filterByMid(items, search);
        if (!search) {
            // this.setState({ filteredItems: this.props.items })
            this.searchResults = this.props.items;
        } else {
            this.searchResults = newArray;
            // this.setState({ filteredItems: newArray })
        }
    }
  

    handleCheckbox(item, event) {
        var checked = event.target.checked;
        item.selected = checked;
        var selected = this.state.items.filter(item => item.selected == true);
        if (selected.length > 0) {
            this.setState({ valid: true });
        } else {
            this.setState({ valid: false })
        }

    }
    handleSubmit() {
        var selected = this.state.items.filter(item => item.selected == true).map(i => i.id);

        enableCwtReprint({ idList: selected })
            .then(response => {
                this.props.onSuccess();
            })
            .catch(error => {
                console.log(error);
            })
    }
    renderCwt(row) {
        if (row.isLast) {
            return (<td>{row.cwt}</td>)
        } else {
            return (<td></td>)
        }
    }
    renderSelection(row, index) {
        if (row.isLast) {
            return (
                <td>
                    <input type="checkbox"
                        id={row.cwt + '_' + row.mid}
                        onChange={(event) => this.handleCheckbox(event, row)}
                        checked={row.selected}
                    ></input>
                </td>
            )
        } else {
            return (<td></td>)
        }
    }
    renderCheckbox(row) {
        if (!row.processedBy) {
            return (
                <>
                    <input type="checkbox"
                        id={row.cwt}
                        onChange={(event) => this.handleCheckbox(row, event)}
                    // checked={row.selected}
                    ></input>
                </>
            )
        } else {
            return null;
        }
    }
    renderRow = (row, index) => {
        return (
            <tr key={index}>
                <td>
                    {this.renderCheckbox(row)}
                </td>
                <td>{row.cwt}</td>
                <td>{row.mid}</td>
                <td>{row.cwtDate}</td>
                <td>{row.numberOfRequest > 2 && row.processedBy ? 'LIMIT REACHED' : row.numberOfRequest}</td>
                <td>{row.lastPrintedBy}</td>
                <td>{row.datePrinted}</td>
                <td>{row.processedBy}</td>
                <td>{row.dateProcessed}</td>


            </tr>
        )
    }

    renderResult = (taxReports) => {

        if (taxReports.length > 0) {
            return (
                <div>
                    <div className="custom-tbl-header">
                        <span>ORIGINAL CWT COPY</span>
                    </div>
                    <div className="tax-reprint-table-container">
                        <table className="custom-tbl">
                            <thead>
                                <tr>
                                    <th>ENABLE REPRINT?</th>
                                    <th>CWT</th>
                                    <th>MID</th>
                                    <th>CWT DATE</th>
                                    <th>NO OF REQUEST</th>
                                    <th>LAST PRINTED BY</th>
                                    <th>DATE PRINTED</th>
                                    <th>PROCESSED BY</th>
                                    <th>DATE PROCESSED</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.pageOfItems.map(this.renderRow)}
                            </tbody>
                        </table>
                    </div>
                    <div className="text-center">
                        <div>
                            <Pagination style={{ display: 'flex', justifyContent: 'center' }}>
                                <Pagination.First onClick={() => this.first()} />
                                <Pagination.Prev onClick={() => this.previous()} />
                                <Pagination.Next onClick={() => this.next()} />
                                <Pagination.Last onClick={() => this.last()} />
                            </Pagination>
                        </div>
                        <div align="center">
                            <span>Page {this.state.currentPage}</span> / {" "}
                            <span>{this.state.totalPages}</span>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <Row>
                    <Col>
                        <div>
                            <span style={{ color: 'red' }}>Sorry, the report you're searching for is no longer available. Please call Merchant Services Hotline Number (+632)8702-6900 or email merchantsvcs@bdo.com.ph</span>
                        </div>
                    </Col>
                </Row>
            )
        }

    }
    renderButtons() {
        if (this.props.items.length > 0) {
            return (
                <div className="tax-reprint-btn">
                    <span><button className="submit-btn" onClick={this.handleSubmit} disabled={!this.state.valid}>OK</button></span>
                    <span><button className="submit-btn" onClick={this.goBack}>Back</button></span>
                </div>
            )
        } else {
            return (
                <div className="tax-reprint-btn">
                    <span>
                        <button className="submit-btn" onClick={this.goBack}>Back</button>
                    </span>
                </div>
            )
        }
    }

    goBack(){
        // e.preventDefault();

        // this.props.history.goBack();
        this.props.back();
    }

    render() {
        return (
            <div>
                {/* <BodyHeaderDiv>
                    <BodyHeaderText>REPRINT REQUEST LOGS</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv> */}
                    <Container fluid={true}>
                        {/* {this.renderResult(this.props.items)} */}
                        {this.renderResult(this.props.items)}
                        {this.renderButtons()}

                    </Container>
                {/* </ContentDiv> */}
            </div>
        );
    }
}
export default TaxReprintList;